(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2442],{

/***/ 52655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ExpandableTextArea_ExpandableTextArea; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./node_modules/emoji-mart/dist-es/index.js + 29 modules
var dist_es = __webpack_require__(37757);
// EXTERNAL MODULE: ./node_modules/emoji-mart/css/emoji-mart.css
var emoji_mart = __webpack_require__(87898);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./components/EmojiPicker/EmojiPicker.module.scss
var EmojiPicker_module = __webpack_require__(81910);
var EmojiPicker_module_default = /*#__PURE__*/__webpack_require__.n(EmojiPicker_module);
;// CONCATENATED MODULE: ./components/EmojiPicker/EmojiPickerDictionary.ts
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getDictionary = function(t) {
    return {
        search: t("Search"),
        clear: t("Clear"),
        notfound: t("No Emoji Found"),
        skintext: t("Choose your default skin tone"),
        categories: {
            search: t("Search Results"),
            recent: t("Frequently Used"),
            people: t("Smileys & People"),
            nature: t("Animals & Nature"),
            foods: t("Food & Drink"),
            activity: t("Activity"),
            places: t("Travel & Places"),
            objects: t("Objects"),
            symbols: t("Symbols"),
            flags: t("Flags"),
            custom: t("Custom")
        },
        categorieslabel: t("Emoji categories"),
        skintones: {
            1: t("Default Skin Tone"),
            2: t("Light Skin Tone"),
            3: t("Medium-Light Skin Tone"),
            4: t("Medium Skin Tone"),
            5: t("Medium-Dark Skin Tone"),
            6: t("Dark Skin Tone")
        }
    };
};
/* harmony default export */ var EmojiPickerDictionary = (getDictionary);

;// CONCATENATED MODULE: ./components/EmojiPicker/EmojiPicker.tsx










var cx = bind_default().bind((EmojiPicker_module_default()));
var EmojiPicker = function(param) {
    var onDismiss = param.onDismiss, onPick = param.onPick, _position = param.position, position = _position === void 0 ? "right" : _position, t = param.t;
    var ref = (0,react.useState)(false), isPickerDisplayed = ref[0], setIsPickerDisplayed = ref[1];
    var handleSelect = function(emoji) {
        var native = emoji.native;
        // eslint-disable-next-line no-unused-expressions
        native && onPick(native);
        setIsPickerDisplayed(false);
    };
    var handleDismiss = function() {
        setIsPickerDisplayed(false);
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("emoji-picker"),
        "data-qa": "emoji-picker",
        children: [
            isPickerDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("emoji-picker__emoji-mart", "emoji-picker__emoji-mart--".concat(position)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "aria-label": t("Close emoji picker"),
                        className: cx("emoji-picker__overlay"),
                        role: "button",
                        tabIndex: 0,
                        onClick: handleDismiss,
                        onKeyPress: handleDismiss
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Picker */.cW, {
                        i18n: EmojiPickerDictionary(t),
                        showPreview: false,
                        showSkinTones: false,
                        autoFocus: true,
                        emojiTooltip: true,
                        native: true,
                        onSelect: handleSelect
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
                title: t("Add emoji"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    appearance: "knockout",
                    ariaLabel: isPickerDisplayed ? t("Close emoji picker") : t("Add emoji"),
                    className: cx("emoji-picker__button", "button--icon-only"),
                    size: "small",
                    onClick: function() {
                        setIsPickerDisplayed(true);
                    },
                    children: isPickerDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        height: "24",
                        viewBox: "4 1 19 19",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            fill: "none",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12,6 C8.7,6 6,8.7 6,12 C6,15.3 8.7,18 12,18 C15.3,18 18,15.3 18,12 C18,8.7 15.3,6 12,6 Z",
                                    fill: "#FFE300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12,6 C15.3,6 18,8.7 18,12 C18,15.3 15.3,18 12,18 C8.7,18 6,15.3 6,12 C6,8.7 8.7,6 12,6 Z M12,6.70588235 C9.08823529,6.70588235 6.70588235,9.08823529 6.70588235,12 C6.70588235,14.9117647 9.08823529,17.2941176 12,17.2941176 C14.9117647,17.2941176 17.2941176,14.9117647 17.2941176,12 C17.2941176,9.08823529 14.9117647,6.70588235 12,6.70588235 Z M9.63529412,13.8705882 C9.77647059,13.7294118 9.98823529,13.7294118 10.1294118,13.8705882 C11.1529412,14.8941176 12.8470588,14.8941176 13.8705882,13.8705882 C14.0117647,13.7294118 14.2235294,13.7294118 14.3647059,13.8705882 C14.5058824,14.0117647 14.5058824,14.2235294 14.3647059,14.3647059 C13.7117647,15.0176471 12.8647059,15.3529412 12,15.3529412 C11.1352941,15.3529412 10.2882353,15.0176471 9.63529412,14.3647059 C9.49411765,14.2235294 9.49411765,14.0117647 9.63529412,13.8705882 Z M10.2352941,9.70588235 C10.7226042,9.70588235 11.1176471,10.1009252 11.1176471,10.5882353 C11.1176471,11.0755454 10.7226042,11.4705882 10.2352941,11.4705882 C9.74798404,11.4705882 9.35294118,11.0755454 9.35294118,10.5882353 C9.35294118,10.1009252 9.74798404,9.70588235 10.2352941,9.70588235 Z M13.7647059,9.70588235 C14.252016,9.70588235 14.6470588,10.1009252 14.6470588,10.5882353 C14.6470588,11.0755454 14.252016,11.4705882 13.7647059,11.4705882 C13.2773958,11.4705882 12.8823529,11.0755454 12.8823529,10.5882353 C12.8823529,10.1009252 13.2773958,9.70588235 13.7647059,9.70588235 Z",
                                    fill: "#000",
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "smiley-face"
                    })
                })
            }, "Add Emoji")
        ]
    });
};
/* harmony default export */ var EmojiPicker_EmojiPicker = (EmojiPicker);

;// CONCATENATED MODULE: ./components/EmojiPicker/index.ts


// EXTERNAL MODULE: ./components/AttachmentButtons/index.ts + 12 modules
var AttachmentButtons = __webpack_require__(40294);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/textHelpers.ts
var textHelpers = __webpack_require__(51661);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./koba/components/Label/index.ts + 1 modules
var Label = __webpack_require__(23185);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/ExpandableTextArea/ExpandableTextArea.module.scss
var ExpandableTextArea_module = __webpack_require__(46666);
var ExpandableTextArea_module_default = /*#__PURE__*/__webpack_require__.n(ExpandableTextArea_module);
;// CONCATENATED MODULE: ./components/ExpandableTextArea/ExpandableTextArea.tsx














var ExpandableTextArea_cx = bind_default().bind((ExpandableTextArea_module_default()));
var ExpandableTextArea = function(param) {
    var attachment = param.attachment, attachmentAltText = param.attachmentAltText, cancelComment = param.cancelComment, color = param.color, handleAttachmentAltTextChange = param.handleAttachmentAltTextChange, handleAttachmentChange = param.handleAttachmentChange, handleBlur = param.handleBlur, handleInputChange = param.handleInputChange, id = param.id, mentionsComponent = param.mentionsComponent, parentPassedRef = param.inputRef, isAlwaysExpanded = param.isAlwaysExpanded, isAttachmentButtonsEnabled = param.isAttachmentButtonsEnabled, isAttachmentRenderedInPortal = param.isAttachmentRenderedInPortal, isEditing = param.isEditing, isModal = param.isModal, isReply = param.isReply, isSubmitDisabled = param.isSubmitDisabled, label = param.label, labelClass = param.labelClass, parentPostRef = param.parentPostRef, _s3UploadPath = param.s3UploadPath, s3UploadPath = _s3UploadPath === void 0 ? "" : _s3UploadPath, submitComment = param.submitComment, t = param.t, value = param.value;
    var cancelButtonRef = react.useRef(null);
    var postButtonRef = react.useRef(null);
    var inputRef = react.useRef();
    var containerClassName = "expandable-text__container";
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width >= constants/* BREAKPOINT_MD */.GI;
    var ref = (0,react.useState)(false), recomputePortal = ref[0], setRecomputePortal = ref[1];
    var ref1 = (0,react.useState)(true), isAttachmentOpen = ref1[0], setIsAttachmentOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isAttachmentUploading = ref2[0], setIsAttachmentUploading = ref2[1];
    var ref3 = (0,react.useState)(isAlwaysExpanded), isExpanded = ref3[0], setIsExpanded = ref3[1];
    var expandedClassName = isExpanded ? "".concat(containerClassName, "--expanded") : "";
    var blurExpandableTextarea = function(cancelRef, buttonRef, parentRef) {
        cancelRef.blur();
        buttonRef.blur();
        if (!isEditing) {
            parentRef.focus();
            blurTextarea();
            // TODO: fix this ridiculous hack to close the FileAttachmentInput after submitting a comment
            setIsAttachmentOpen(false);
            setIsAttachmentOpen(true);
        }
    };
    var getInputRef = function() {
        return parentPassedRef ? parentPassedRef.current : inputRef.current;
    };
    (0,react.useEffect)(function() {
        // re-calculate the portal element after the component is mounted
        if (isAttachmentRenderedInPortal) {
            setRecomputePortal(true);
        }
    }, []);
    var handleCancelComment = function(cancelButton, postButton, parentPost) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cancelRef, postRef, parentRef;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cancelRef = cancelButton.current;
                        postRef = postButton.current;
                        parentRef = parentPost.current;
                        if (!cancelComment) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return cancelComment();
                    case 6:
                        blurExpandableTextarea(cancelRef, postRef, parentRef);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var handleEmojiPick = function(emoji) {
        var inputElement = getInputRef();
        if (inputElement) {
            var selectionStart = inputElement.selectionStart, inputValue = inputElement.value;
            var updatedContent = (0,mentions/* insertEmoji */.Q0)(emoji, selectionStart, inputValue, value);
            handleInputChange(updatedContent);
            inputElement.focus();
        }
    };
    var handleSubmitComment = function(cancelButton, postButton, parentPost) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cancelElement, postElement, parentElement;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        cancelElement = cancelButton.current;
                        postElement = postButton.current;
                        parentElement = parentPost.current;
                        focusTextarea();
                        if (!submitComment) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return submitComment();
                    case 7:
                        blurExpandableTextarea(cancelElement, postElement, parentElement);
                        if (handleBlur) handleBlur();
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var primaryBtnText = isReply ? "Post reply" : "Post comment";
    var handleOnBlur = function(e) {
        if (!isReply) {
            return;
        }
        var currentTarget = e.currentTarget;
        setTimeout(function() {
            if (!currentTarget.contains(document.activeElement)) {
                var ref = getInputRef();
                if (ref) {
                    var ref1;
                    var val = (ref1 = getInputRef()) === null || ref1 === void 0 ? void 0 : ref1.value;
                    if (!val) {
                        if (handleBlur) handleBlur();
                    }
                }
            }
        }, 0);
    };
    var onAttachmentAltTextChange = (0,react.useCallback)(function(altText) {
        if (handleAttachmentAltTextChange) handleAttachmentAltTextChange(altText);
    }, [
        attachment
    ]);
    var onAttachmentChange = (0,react.useCallback)(function(newAttachment) {
        setIsExpanded(newAttachment !== null);
        setIsAttachmentUploading(false);
        if (handleAttachmentChange) handleAttachmentChange(newAttachment);
    }, [
        attachment,
        recomputePortal
    ]);
    var onAttachmentUploading = (0,react.useCallback)(function() {
        setIsAttachmentUploading(true);
        focusTextarea();
    }, [
        attachment,
        recomputePortal
    ]);
    var onFilePickerOpen = (0,react.useCallback)(function(isExpandedLocal) {
        setIsExpanded(isExpandedLocal); // when the file picker is open, keep the textarea expanded
    }, [
        attachment,
        recomputePortal
    ]);
    var executeMethodsOnTextarea = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _method = ref.method, method = _method === void 0 ? "focus" : _method;
        if (parentPassedRef && parentPassedRef.current) {
            // @ts-ignore
            var input = parentPassedRef.current.input;
            input = parentPassedRef.current;
            input[method]();
        } else if (inputRef && inputRef.current) {
            // @ts-ignore
            var input1 = inputRef.current.input;
            input1 = inputRef.current;
            input1[method]();
        }
    };
    var focusTextarea = function() {
        executeMethodsOnTextarea();
    };
    var blurTextarea = function() {
        executeMethodsOnTextarea({
            method: "blur"
        });
    };
    var onFocusTextarea = (0,react.useCallback)(function() {
        return focusTextarea();
    }, [
        attachment
    ]);
    var clonedMentionsArea = /*#__PURE__*/ react.cloneElement(mentionsComponent, {
        forwardRef: parentPassedRef || inputRef,
        isExpanded: isExpanded
    });
    // @ts-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ExpandableTextArea_cx("full-width", {
            "mentions-enabled-post-detail":  true && !isModal
        }),
        onBlur: handleOnBlur,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                className: ExpandableTextArea_cx("expandable-text__label", labelClass),
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ExpandableTextArea_cx(containerClassName, expandedClassName),
                tabIndex: -1,
                children: [
                    clonedMentionsArea,
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ExpandableTextArea_cx("actions"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "attachment-input__portal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ExpandableTextArea_cx("actions__wrapper"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ExpandableTextArea_cx("actions__wrapper__left-container"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiPicker_EmojiPicker, {
                                                t: t,
                                                onDismiss: focusTextarea,
                                                onPick: handleEmojiPick
                                            }),
                                            isAttachmentButtonsEnabled && isAttachmentOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons/* default */.Z, {
                                                altText: attachmentAltText,
                                                attachment: attachment,
                                                inputRef: parentPassedRef || inputRef,
                                                isAttachmentRenderedInPortal: isAttachmentRenderedInPortal,
                                                s3UploadPath: s3UploadPath,
                                                isIconOnly: true,
                                                onAltTextChange: onAttachmentAltTextChange,
                                                onAttachmentClicked: onFocusTextarea,
                                                onChange: onAttachmentChange,
                                                onFilePickerOpen: onFilePickerOpen,
                                                onUploading: onAttachmentUploading
                                            })
                                        ]
                                    }),
                                    parentPostRef && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                appearance: "knockout",
                                                className: ExpandableTextArea_cx("actions__cancel"),
                                                ref: cancelButtonRef,
                                                size: "small",
                                                onClick: handleCancelComment(cancelButtonRef, postButtonRef, parentPostRef),
                                                children: t("common-cancel", "Cancel")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                appearance: "default",
                                                color: color,
                                                dataQA: "save-changes__btn",
                                                isDisabled: !attachment && !(0,textHelpers/* isValidText */.Gq)(value) || isSubmitDisabled || isAttachmentUploading,
                                                ref: postButtonRef,
                                                size: "small",
                                                onClick: handleSubmitComment(cancelButtonRef, postButtonRef, parentPostRef),
                                                children: t(isEditing ? "Save changes" : primaryBtnText)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ExpandableTextArea_ExpandableTextArea = (ExpandableTextArea);

;// CONCATENATED MODULE: ./components/ExpandableTextArea/index.ts



/***/ }),

/***/ 81910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EmojiPicker_sr-only--mobile__RbThE","sr-only":"EmojiPicker_sr-only__OgkdJ","error-message":"EmojiPicker_error-message__jo6of","form-inline-edit":"EmojiPicker_form-inline-edit__pVOjT","form-group":"EmojiPicker_form-group__0rZd5","form-row":"EmojiPicker_form-row__m5u7Y","form-inline":"EmojiPicker_form-inline__gMvLQ","error":"EmojiPicker_error__vp9l9","input-group-append":"EmojiPicker_input-group-append__rHjV4","input-group-currency":"EmojiPicker_input-group-currency__qFCUA","form-control":"EmojiPicker_form-control__wLLBt","custom-select":"EmojiPicker_custom-select__1lTyA","is-invalid":"EmojiPicker_is-invalid__F3Pe_","is-valid":"EmojiPicker_is-valid__DXyjM","input-group":"EmojiPicker_input-group__PK4m4","input-group-text":"EmojiPicker_input-group-text__B4eGF","input-group-prepend":"EmojiPicker_input-group-prepend__Sxysw","valid-feedback":"EmojiPicker_valid-feedback__xvoQH","invalid-feedback":"EmojiPicker_invalid-feedback__gYw5W","form-text":"EmojiPicker_form-text__RBS0l","label":"EmojiPicker_label__ZxEhs","custom-control":"EmojiPicker_custom-control__Ok_YS","custom-control-label":"EmojiPicker_custom-control-label__d8kML","custom-control-label--empty":"EmojiPicker_custom-control-label--empty__wHenp","custom-control-input":"EmojiPicker_custom-control-input__l2phw","emoji-picker":"EmojiPicker_emoji-picker__HTiO_","emoji-picker__button":"EmojiPicker_emoji-picker__button__4JGg9","emoji-picker__overlay":"EmojiPicker_emoji-picker__overlay__fCCSz","emoji-picker__emoji-mart":"EmojiPicker_emoji-picker__emoji-mart__PmFry","emoji-picker__emoji-mart--left":"EmojiPicker_emoji-picker__emoji-mart--left__r_Gjr","emoji-picker__emoji-mart--right":"EmojiPicker_emoji-picker__emoji-mart--right__Ybt03"};

/***/ }),

/***/ 46666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ExpandableTextArea_sr-only--mobile__RD9AK","sr-only":"ExpandableTextArea_sr-only__QT6b7","error-message":"ExpandableTextArea_error-message__dRAPL","form-inline-edit":"ExpandableTextArea_form-inline-edit__RYmTz","form-group":"ExpandableTextArea_form-group__AWsV_","form-row":"ExpandableTextArea_form-row__hbWjp","form-inline":"ExpandableTextArea_form-inline__JdVU1","error":"ExpandableTextArea_error__T6shW","input-group-append":"ExpandableTextArea_input-group-append__MIZCj","input-group-currency":"ExpandableTextArea_input-group-currency__2klPF","form-control":"ExpandableTextArea_form-control__4lNQP","custom-select":"ExpandableTextArea_custom-select__nrbVx","is-invalid":"ExpandableTextArea_is-invalid__tNOwC","is-valid":"ExpandableTextArea_is-valid__KkVxL","input-group":"ExpandableTextArea_input-group___Udif","input-group-text":"ExpandableTextArea_input-group-text__Gn4CN","input-group-prepend":"ExpandableTextArea_input-group-prepend__7o4Wi","valid-feedback":"ExpandableTextArea_valid-feedback__zCUZJ","invalid-feedback":"ExpandableTextArea_invalid-feedback__DU3B1","form-text":"ExpandableTextArea_form-text__dAkap","label":"ExpandableTextArea_label__qt_g7","custom-control":"ExpandableTextArea_custom-control__TOB_F","custom-control-label":"ExpandableTextArea_custom-control-label__9po6g","custom-control-label--empty":"ExpandableTextArea_custom-control-label--empty__x4_9u","custom-control-input":"ExpandableTextArea_custom-control-input__e78o_","expandable-text__label":"ExpandableTextArea_expandable-text__label__xxC2O","expandable-text__container":"ExpandableTextArea_expandable-text__container__NHFnT","actions__wrapper":"ExpandableTextArea_actions__wrapper__e3LzY","actions__cancel":"ExpandableTextArea_actions__cancel__W9ayv","actions__wrapper__left-container":"ExpandableTextArea_actions__wrapper__left-container__o_zJS","expandable-text__container--expanded":"ExpandableTextArea_expandable-text__container--expanded__fmIao","expandable-text__element":"ExpandableTextArea_expandable-text__element__Gx_7u","expandable-text__element-wrapper":"ExpandableTextArea_expandable-text__element-wrapper__Hu1Ns","full-width":"ExpandableTextArea_full-width__9ucoE","mentions-enabled-post-detail":"ExpandableTextArea_mentions-enabled-post-detail__GVNYE"};

/***/ })

}]);